export default "__VITE_ASSET__CJXA9qT6__"